import {
  Autocomplete,
  Chip,
  TextField,
} from '@mui/material';

type Props = {
  label: string;
  noSelectionLabel?: string;
  placeholder?: string;
  options: string[];
  value: string[];
  onChange: (newValue: string[]) => void;
}

export default function AutocompleteMultiSelect({
  label,
  noSelectionLabel,
  placeholder = "選択または検索",
  options,
  value,
  onChange
}: Props) {
  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={options}
      value={value || null}
      onChange={(_, newValue) => {
        onChange(newValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          placeholder={placeholder}
          InputProps={{...(noSelectionLabel ?
            {
              ...params.InputProps,
              startAdornment: value?.length === 0 ? (
                <Chip
                  label={noSelectionLabel}
                  disabled
                  sx={{ m: 0.5, fontStyle: 'italic' }}
                />
              ) : (
                params.InputProps.startAdornment
              ),
            } : { ...params.InputProps })
          }}
        />
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          const { key, ...restOfProps } = getTagProps({ index });
          return (
            <Chip
              key={key}
              variant="outlined"
              label={option}
              {...restOfProps}
            />
          );
        })
      }
    />
  );
}
